import axios from "axios";

export const state = {
    patientpayments: [],
};

export const getters = {
    patientpayments: state => state.patientpayments,
};

export const mutations = {
    setPayments(state, newValue) {
        state.patientpayments = newValue
    },
};

export const actions = {
    fetchPatientPayments({ commit }) {
        axios.get('/patientpayments').then(res => {
            commit('setPayments', res.data.visits)
        })
    },
    filterPatientPayments({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterpatientpayments";
        axios.post(url, formData).then((response) => {
            commit('setPayments', response.data.visits)
        })
    },
};
